import React, { useState } from "react";
import { Container, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import AdminCompany from "./AdminCompany";
import AdminSim from "./AdminSim";
import AdminDevice from "./AdminDevice";
import AdminDeviceRecord from "./AdminDeviceRecord";
import AdminDeviceContract from "./AdminDeviceContract";
import AdminDeviceIssue from "./AdminDeviceIssue";

export const ADMIN_TAB_COMPANY = "ADMIN_TAB_COMPANY";
export const ADMIN_TAB_SIM = "ADMIN_TAB_SIM";
export const ADMIN_TAB_DEVICE = "ADMIN_TAB_DEVICE";
export const ADMIN_TAB_DEVICE_RECORD = "ADMIN_TAB_DEVICE_RECORD";
export const ADMIN_TAB_DEVICE_CONTRACT = "ADMIN_TAB_DEVICE_CONTRACT";
export const ADMIN_TAB_DEVICE_ISSUE = "ADMIN_TAB_DEVICE_ISSUE";

function Admin() {
  const { t } = useTranslation();
  const [tab, setTab] = useState(ADMIN_TAB_COMPANY);
  const [simSelectedCompany, setSimSelectedCompany] = useState(null);
  const [deviceSelectedCompany, setDeviceSelectedCompany] = useState(null);
  const [deviceRecordSelectedDevice, setDeviceRecordSelectedDevice] = useState({
    companyID: null,
    deviceID: null
  });
  const [deviceContractSelectedDevice, setDeviceContractSelectedDevice] = useState({
    companyID: null,
    deviceID: null
  });

  const toggleCustom = (newTab) => {
    if (tab !== newTab) {
      setTab(newTab);
    }
  };

  return (
    <React.Fragment>
      <div id="page-admin" className="page-content">
        <Container fluid className="p-0">
          <Nav tabs className="nav nav-tabs nav-tabs-custom nav-primary">
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: tab === ADMIN_TAB_COMPANY,
                })}
                onClick={() => {
                  toggleCustom(ADMIN_TAB_COMPANY);
                }}
              >
                {t('PageAdmin.Tab.Company')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: tab === ADMIN_TAB_SIM,
                })}
                onClick={() => {
                  toggleCustom(ADMIN_TAB_SIM);
                }}
              >
                {t('PageAdmin.Tab.SimCard')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: tab === ADMIN_TAB_DEVICE,
                })}
                onClick={() => {
                  toggleCustom(ADMIN_TAB_DEVICE);
                }}
              >
                {t('PageAdmin.Tab.Device')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: tab === ADMIN_TAB_DEVICE_RECORD,
                })}
                onClick={() => {
                  toggleCustom(ADMIN_TAB_DEVICE_RECORD);
                }}
              >
                {t('PageAdmin.Tab.DeviceRecord')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: tab === ADMIN_TAB_DEVICE_ISSUE,
                })}
                onClick={() => {
                  toggleCustom(ADMIN_TAB_DEVICE_ISSUE);
                }}
              >
                {t('PageAdmin.Tab.DeviceIssue')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: tab === ADMIN_TAB_DEVICE_CONTRACT,
                })}
                onClick={() => {
                  toggleCustom(ADMIN_TAB_DEVICE_CONTRACT);
                }}
              >
                {t('PageAdmin.Tab.ContractRecord')}
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent
            activeTab={tab}
            className="text-muted admin-tab-container"
          >
            <TabPane tabId={ADMIN_TAB_COMPANY} style={{ height: '100%' }}>
              <div className="d-flex flex-column" style={{ height: '100%' }}>
                <AdminCompany 
                  toggleTag={(tagID) => { toggleCustom(tagID) }} 
                  onSelectedSimCompany={(selectedSimCardCompany) => {setSimSelectedCompany(selectedSimCardCompany); toggleCustom(ADMIN_TAB_SIM);}}
                  onSelectedDeviceCompany={(selectedDeviceCompany) => {setDeviceSelectedCompany(selectedDeviceCompany); toggleCustom(ADMIN_TAB_DEVICE);}}
                />
              </div>
            </TabPane>
            <TabPane tabId={ADMIN_TAB_SIM} style={{ height: '100%' }}>
              <div className="d-flex flex-column" style={{ height: '100%' }}>
                <AdminSim toggleTag={(tagID) => { toggleCustom(tagID) }} selectedCompany={simSelectedCompany}/>
              </div>
            </TabPane>
            <TabPane tabId={ADMIN_TAB_DEVICE} style={{ height: '100%' }}>
              <div className="d-flex flex-column" style={{ height: '100%' }}>
                <AdminDevice toggleTag={(tagID) => { toggleCustom(tagID) }} 
                  selectedCompany={deviceSelectedCompany} 
                  onSelectedUpdateDevice={(device) => {setDeviceRecordSelectedDevice(device); toggleCustom(ADMIN_TAB_DEVICE_RECORD);}}
                  onSelectedContractDevice={(device) => {setDeviceContractSelectedDevice(device); toggleCustom(ADMIN_TAB_DEVICE_CONTRACT);}}
                  />
              </div>
            </TabPane>
            <TabPane tabId={ADMIN_TAB_DEVICE_RECORD} style={{ height: '100%' }}>
              <div className="d-flex flex-column" style={{ height: '100%' }}>
                <AdminDeviceRecord toggleTag={(tagID) => { toggleCustom(tagID) }} 
               selectedDevice={deviceRecordSelectedDevice}
              />
              </div>
            </TabPane>
            <TabPane tabId={ADMIN_TAB_DEVICE_ISSUE} style={{ height: '100%' }}>
              <div className="d-flex flex-column" style={{ height: '100%' }}>
                <AdminDeviceIssue toggleTag={(tagID) => { toggleCustom(tagID) }} 
               selectedDevice={deviceRecordSelectedDevice}
              />
              </div>
            </TabPane>
            <TabPane tabId={ADMIN_TAB_DEVICE_CONTRACT} style={{ height: '100%' }}>
              <div className="d-flex flex-column" style={{ height: '100%' }}>
                <AdminDeviceContract toggleTag={(tagID) => { toggleCustom(tagID) }} 
                  selectedDevice={deviceContractSelectedDevice}
                />
              </div>
            </TabPane>
          </TabContent>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default Admin;
